<template>
    <div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">
                <div class="ml-auto text-right mb-3">
                    <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                               :data="exportData"
                               :fields="exportFields"
                               :header="exportHeaders"
                               type="csv"
                               :escapeCsv="false"
                               :name="exportFileName">
                        <span>CSV</span>
                    </exportCSV>
                    <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                    <span class="mr-3">PDF</span>
                    <i class="arrow-down fas fa-angle-down"></i> 
                </button> -->
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-4 align-items-center justify-content-start">
                        <div class="dataTables_filter mb-2">
                            <label class="d-flex mb-0">
                                <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                       :placeholder="$t('label.search')" v-model="searchMember" @keypress.enter="searchMemberList">
                                <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                                        @click="searchMemberList()">
                                    <i class="fas fa-search"></i>
                                </button>
                            </label>
                        </div>
                    </div>
                    <div v-show="selectedTabView == 'active'" class="col-sm-12 col-md-4 mb-2">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-calendar-check"></i>
                                    </label>
                                    <multiselect :value="selectedVisit" label="text" track-by="id" :options="lastVisits" :searchable="false"
                                                 :show-labels="false" openDirection="below" @select="filterLastVisit"></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2 col-sm-12 col-md-4">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-birthday-cake"></i>
                                    </label>
                                    <multiselect :value="selectedBday" label="text" track-by="id" :options="birthdays" :searchable="false"
                                                 :show-labels="false" openDirection="below" @select="filterBirthday"></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <ul class="nav nav-tabs">
                        <li class="nav-item" v-for="membershipTab in $i18n.messages[$i18n.locale].tab.membershipTabs" :key="membershipTab.id">
                            <a :class="{ 'active': selectedMembershipTab == membershipTab.id }" class="nav-link"
                                @click="filterMembership(membershipTab.id)">{{ membershipTab.text }}</a>
                        </li>
                    </ul> -->
                </div>
                <div class="row">
                    <div class="mt-3 col-md-6 col-lg-6 col-xl-4 d-flex flex-column">
                        <b-button-group size="sm">
                        <b-button
                            v-for="membershipTab of membershipTabs"
                            :key="'membershipTab' + membershipTab.id"
                            variant="outline-primary"
                            :class="lastVisitFilter === membershipTab.id ? 'active' : ''"
                            @click="lastVisitFilter = membershipTab.id"
                            >
                            {{ membershipTab.text }}
                        </b-button>
                        </b-button-group>
                    </div>
                </div>
                <br>
                <a class="link text-primary" @click="clearFilter">{{ $t('button_link.clear_filter') }}</a>
            </div>
            <div class="panel-container">
                <div class="panel-content">
                    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{ $t('table.no_records') }}</div>
                    <div class="dataTables_wrapper dt-bootstrap4" v-if="!isSpinnerShow && totalEntries != 0">
                        <!-- <div class="row justify-content-end mt-2">
                            <div class="col-auto pt-2">
                                <span>{{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}</span>
                            </div>
                            <div class="col-auto">
                                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                              @input="handlePagination"></b-pagination>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table striped hover :fields="fields" :items="memberLists" responsive>
                                    <template #cell(index)="data">
                                        {{ data.index + startPage }}
                                    </template>
                                    <template #cell(img)="data">
                                        <img class="profile-image-md rounded-circle"
                                             :src="data.item.icon != '' ? getMemberImage(data.item.icon) : require('@/assets/image/icon/profile.png')" />
                                    </template>
                                    <template #cell(name)="data">
                                        <!-- {{ data }} -->
                                        <div class="font-weight-bold">{{ data.item.name }}</div>
                                        <div class="align-middle">
                                            <span class="badge badge-pill badge-success"><i class="fas fa-phone"></i></span>
                                            {{ data.item.mobile }}
                                        </div>
                                    </template>
                                    <template #cell(lastVisit)="data">
                                        {{ getMemberLastVisit(data.item.lastSale) }}
                                    </template>
                                    <template #cell(bday)="data">
                                        {{ getMemberDob(data.item.dob) }}
                                    </template>
                                    <template #cell(membership)="data">
                                        <h6 v-if="data.item.vip == '0' && data.item.vvip == '0' && data.item.vvvip == '0'">
                                            <span class="badge border border-secondary text-secondary fw-400">N/A</span>
                                        </h6>
                                        <h6 class="d-inline-block mr-2" v-if="data.item.vip != '0'">
                                            <span class="badge badge-primary">{{ membershipTabs[1].text }}</span>
                                        </h6>
                                        <h6 class="d-inline-block mr-2" v-if="data.item.vvip != '0'">
                                            <span class="badge badge-danger">{{ membershipTabs[2].text }}</span>
                                        </h6>
                                        <h6 class="d-inline-block mr-2" v-if="data.item.vvvip != '0'">
                                            <span class="badge badge-warning">{{ membershipTabs[3].text }}</span>
                                        </h6>
                                    </template>
                                    <template #cell(gallery)="data">
                                        <a class="link text-primary" :title="$t('button_link.view_update', { 'item': $t('table.header.gallery') })"
                                           @click="editGallery(data.item)">
                                            <i class="fal fa-images fs-xl"></i>
                                        </a>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <memberGallery ref="memberGallery"></memberGallery>
    </div>
</template>
<script>
import MemberGallery from './Member_Gallery'
import moment from 'moment'
import { handleSessionExpired, setReturnData } from './../../../../assets/js/dashboard/dashboard.js'
import { all } from 'q'
export default {
    name: 'memberList',
    components: {
        MemberGallery
    },
    data() {
        let selectedTab = this.$i18n.messages[this.$i18n.locale].tab.membershipTabs[0].id
        return {
            selectedTabView: "active",
            searchMember: "", isSpinnerShow: false,
            searchFilter: "",
            selectedVisit: {},
            selectedBday: {}, birthdayFilter: "",
            membershipTabs: [], selectedMembershipTab: selectedTab,
            memberData: [],
            memberLists: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFields: {}, exportFileName: "", memberExportData: [],
            lastVisitFilter: 'all',
        }
    },
    computed: {
        fields() {
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "img", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center' },
                { key: "name", label: this.$i18n.t('table.header.customer'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "lastVisit", label: this.$i18n.t('table.header.last_visit'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "bday", label: this.$i18n.t('table.header.birthday'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "membership", label: this.$i18n.t('table.header.membership'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "gallery", label: this.$i18n.t('table.header.gallery'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center' },
            ]
        },
        lastVisits() {
            return [
                { id: 'all', text: this.$i18n.t('member.lastVisits.all') },
                { id: 'one', text: this.$i18n.t('member.lastVisits.one') },
                { id: 'three', text: this.$i18n.t('member.lastVisits.three') },
                { id: 'six', text: this.$i18n.t('member.lastVisits.six') },
                { id: 'more', text: this.$i18n.t('member.lastVisits.more') }
            ]
        },
        birthdays() {
            return [
                { id: 'all', text: this.$i18n.t('member.birthdays.all') },
                { id: 'today', text: this.$i18n.t('member.birthdays.today') },
                { id: 'last', text: this.$i18n.t('member.birthdays.last') },
                { id: 'this', text: this.$i18n.t('member.birthdays.this') },
                { id: 'next', text: this.$i18n.t('member.birthdays.next') }
            ]
        },
    },
    watch: {
        "$i18n.locale"(val) {
            if (Array.isArray(this.selectedBday)) {
                this.selectedBday = this.selectedBday[0]
            }
            if (Array.isArray(this.selectedVisit)) {
                this.selectedVisit = this.selectedVisit[0]
            }
            var b = Object.assign({}, this.selectedBday)
            var v = Object.assign({}, this.selectedVisit)

            this.selectedVisit = this.lastVisits.filter(obj => obj.id == v.id)
            this.selectedBday = this.birthdays.filter(obj => obj.id == b.id)

            this.setExportData(this.memberExportData)
        },
        lastVisitFilter(val) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedMembershipTab = val;
            this.loadMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
    },
    methods: {
        getMemberImage(img) {
            return img;
        },
        getMemberDob(dob) {
            if(!dob || dob == '0000-00-00') {
                return '-'
            }

            let temp = moment(dob, 'YYYY-MM-DD')
            if(!temp.isValid()) {
                return '-'
            }

            return temp.format('DD/MM/YYYY')
        },
        getMemberLastVisit(lastSale) {
            if(!lastSale || !lastSale.salesDate) {
                return '-'
            }

            let temp = moment.unix(lastSale.salesDate)
            return temp.format('DD/MM/YYYY')
        },

        filterMemberByView(tab) {
            this.page = 0;
            this.selectedTabView = tab;
            this.clearFilter()
        },
        clearFilter() {
            this.searchMember = this.searchFilter = this.birthdayFilter = ""
            this.selectedVisit = this.lastVisits[0];
            this.selectedBday = this.birthdays[0];
            this.selectedMembershipTab = "all"
            this.lastVisitFilter = "all"
            this.loadMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
        searchMemberList() {
            this.page = 0;
            this.currentPage = 1;
            this.loadMemberList();
        },
        filterMembership(id) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedMembershipTab = id;
            this.loadMemberList();
        },
        filterLastVisit(item) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedVisit = item;
            this.loadMemberList();
        },
        filterBirthday(item) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedBday = item
            this.loadMemberList();
        },
        handlePagination(pg) {
            if (pg != null) {
                this.page = pg - 1
                this.loadMemberList();
                //document.getElementById('btnToTop').click(); 
            }
        },

        async getMembershipTags() {
            let $vm = this

            var init = ["vip", "vvip", "vvvip"];
            $vm.membershipTabs.push({ id: "all", text: "All" });
            await $vm.$axios({
                method: 'get',
                url: this.$api.MEMBER_CONFIGURE,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then(function (response) {
                    var results = response.data.vip;

                    for (var i = 0; i < results.length; i++) {
                        $vm.membershipTabs.push({ id: init[i], text: results[i] });
                        $vm.selectedMembershipTab = $vm.membershipTabs[0].id
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        loadMemberList() {
            let querystring = this.selectedMembershipTab == "all" ? "" : "&" + this.selectedMembershipTab + "=1";

            let now = moment()

            switch (this.selectedVisit.id) {
                case "one":
                    querystring += `&lastSaleStart=${moment(now).subtract(1, 'month').startOf('day').unix()}&lastSaleStop=${moment(now).endOf('day').unix()}`
                    break;
                case "three":
                    querystring += `&lastSaleStart=${moment(now).subtract(3, 'month').startOf('day').unix()}&lastSaleStop=${moment(now).subtract(1, 'month').endOf('day').unix()}`
                    break;
                case "six":
                    querystring += `&lastSaleStart=${moment(now).subtract(6, 'month').startOf('day').unix()}&lastSaleStop=${moment(now).subtract(3, 'month').endOf('day').unix()}`
                    break;
                case "more":
                    querystring += `&lastSaleStart=0&lastSaleStop=${moment(now).subtract(6, 'month').endOf('day').unix()}`
                    break;
            }

            switch (this.selectedBday.id) {
                case "today":
                    querystring += `&dobMonth=${moment(now).format('MM')}&dobDay=${moment(now).format('DD')}`
                    break;
                case "last":
                    querystring += `&dobMonth=${moment(now).subtract(1, 'month').format('MM')}`
                    break;
                case "this":
                    querystring += `&dobMonth=${moment(now).format('MM')}`
                    break;
                case "next":
                    querystring += `&dobMonth=${moment(now).add(1, 'month').format('MM')}`
                    break;
            }

            querystring += this.searchMember ? "&search=" + this.searchMember : "";
            querystring += this.selectedTabView === "hidden" ? "&hiddenMember=1" : "";

            this.loadMemberListActual(querystring)
        },
        async loadMemberListActual(strFilter) {
            this.isSpinnerShow = true
            var result = await this.getMemberList("?page=" + this.page + strFilter)
            var retData = setReturnData(result.result, result.count, this.page)
            this.memberLists = retData.result;
            this.totalEntries = result.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;

            this.isSpinnerShow = false;

            this.getMemberList("?" + strFilter, true)
            // var exportResult = await this.getMemberList("?" + strFilter)
            // this.memberExportData = exportResult.result
            // this.setExportData(exportResult.result)
        },
        async getMemberList(strFilter, isExport) {
            let $vm = this
            let QUERY_STRING = strFilter
            let url = this.$api.BIZ_MEMBER + QUERY_STRING

            var result = {}
            await $vm.$axios({
                method: 'get',
                url: url,
                baseURL: this.$api.API_ENDPOINT_MEMBER,
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    if(isExport) {
                        this.memberExportData = response.data['members']
                        this.setExportData(this.memberExportData)
                        return
                    }

                    result = { result: response.data['members'] }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
            return result
        },

        setExportData(members) {
            this.exportFields = {}
            this.exportFields["#"] = "index";
            this.exportFields[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            this.exportFields[(this.$i18n.t('table.header.contact')).toUpperCase()] = "contact"
            this.exportFields[(this.$i18n.t('table.header.birthday')).toUpperCase()] = "birthday"
            this.exportFields[this.membershipTabs[1].text] = this.membershipTabs[1].text;
            this.exportFields[this.membershipTabs[2].text] = this.membershipTabs[2].text;
            this.exportFields[this.membershipTabs[3].text] = this.membershipTabs[3].text;

            this.exportData = [];
            for (var i = 0; i < members.length; i++) {
                var data = {}
                data["index"] = i + 1;
                data["name"] = members[i].name
                data["contact"] = "+" + (members[i].mobile).toString()
                data["birthday"] = this.getMemberDob(members[i].dob)
                data[this.membershipTabs[1].text] = members[i].memberVip == '0' ? "-" : "Yes"
                data[this.membershipTabs[2].text] = members[i].memberVvip == '0' ? "-" : "Yes"
                data[this.membershipTabs[3].text] = members[i].memberVvvip == '0' ? "-" : "Yes"
                this.exportData.push(data)
            }

            var type = this.$i18n.messages[this.$i18n.locale].tab.memberTabLists.filter(obj => obj.id == this.selectedTabView)
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_member`) + " (" + type[0].text + ")"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), " "];
            this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV
        },

        editGallery(item) {
            this.$refs.memberGallery.editMemberGallery(item)
        }
    },
    async mounted() {
        let $vm = this;
        await $vm.getMembershipTags();

        $vm.selectedVisit = $vm.lastVisits[0]
        $vm.selectedBday = $vm.birthdays[0]
        $vm.loadMemberList();
    }
}
</script>
<style scoped>.link,
.nav-link {
    cursor: pointer;
}</style>